// Shared status pill colour mapping for appraisal & job statuses.
// Handles both canonical and legacy Access status names.
export function statusPillClasses(status) {
  const s = (status || '').toLowerCase().trim();
  if (!s) return 'bg-slate-100 text-slate-500 ring-1 ring-slate-200';
  if (s.includes('paid')) return 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100';
  if (s.includes('completed') || s === 'work complete' || s.includes('complete') && !s.includes('quote')) return 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100';
  if (s.includes('invoiced')) return 'bg-teal-50 text-teal-700 ring-1 ring-teal-100';
  if (s.includes('accepted') || s.includes('work booked') || s.includes('progress')) return 'bg-blue-50 text-blue-700 ring-1 ring-blue-100';
  if (s.includes('quoted') || s.includes('quote') || s.includes('follow up') || s.includes('follow-up')) return 'bg-amber-50 text-amber-700 ring-1 ring-amber-100';
  if (s.includes('booked') || s.includes('required') || s.includes('appraisal')) return 'bg-orange-50 text-orange-700 ring-1 ring-orange-100';
  if (s.includes('declined') || s.includes('cancelled') || s.includes('lost') || s.includes('written') || s.includes('overdue')) return 'bg-rose-50 text-rose-700 ring-1 ring-rose-100';
  if (s.includes('closed')) return 'bg-slate-100 text-slate-600 ring-1 ring-slate-200';
  return 'bg-slate-100 text-slate-600 ring-1 ring-slate-200';
}

export function statusDotColour(status) {
  const s = (status || '').toLowerCase().trim();
  if (!s) return '#94A3B8';
  if (s.includes('paid')) return '#059669';
  if (s.includes('completed') || s === 'work complete') return '#059669';
  if (s.includes('invoiced')) return '#0D9488';
  if (s.includes('accepted') || s.includes('work booked') || s.includes('progress')) return '#2563EB';
  if (s.includes('quoted') || s.includes('quote') || s.includes('follow up') || s.includes('follow-up')) return '#D97706';
  if (s.includes('booked') || s.includes('required') || s.includes('appraisal')) return '#EA580C';
  if (s.includes('declined') || s.includes('cancelled') || s.includes('lost') || s.includes('written') || s.includes('overdue')) return '#E11D48';
  if (s.includes('closed')) return '#64748B';
  return '#64748B';
}

export function getInitials(first, last) {
  const f = (first || '').trim();
  const l = (last || '').trim();
  if (!f && !l) return '?';
  return ((f[0] || '') + (l[0] || '')).toUpperCase() || (f[0] || l[0] || '?').toUpperCase();
}
